<script lang="ts" setup>
import type { CodeGroupProps } from '.';

import {
	CommandGroup,
	CommandItem
} from '@/components/SearchSuggestRadixCommand';
import { cn } from '@/utils';

defineProps<CodeGroupProps>();
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
	<CommandGroup class="p-0">
		<template #heading>
			<div
				:class="
					cn(
						'flex h-12 cursor-default items-center gap-3 px-4 font-matter-sq text-lg font-normal leading-normal tracking-[-0.36px] text-primary',
						groupHeadingClasses
					)
				"
			>
				<IconMaterialSymbolsLightTag :class="cn('size-5', groupIconClasses)" />
				Código de imóvel
			</div>
		</template>

		<CommandItem
			v-for="suggestion in suggestions"
			:key="`search-suggest-code-option-${suggestion.result.title}`"
			:value="suggestion"
			:class="
				cn(
					'flex cursor-pointer items-center justify-between py-4 pl-12 pr-4 data-highlighted:bg-white-dark-2',
					groupItemWrapperClasses
				)
			"
		>
			<p
				:class="
					cn(
						'flex flex-col text-start text-base font-normal leading-normal text-primary',
						groupItemTextClasses
					)
				"
			>
				Buscar "{{ suggestion.result.title.toUpperCase() }}" como possível
				imóvel
			</p>

			<IconPilarCircularProgress
				v-show="isFetchingPropertyByCodeSearch"
				class="size-5 animate-spin text-white-dark-4"
			/>
		</CommandItem>
	</CommandGroup>
</template>
